// The ticker's SGP badges come from getCachedSGPs, which the HTTP gate
// (functions/utils/httpGate.js) limits to signed-in users. Signed-out visitors
// would only collect 401s, so the ticker skips the check for them.

/** Whether the ticker should ask getCachedSGPs for SGP badges. */
export const shouldCheckSgpBadges = ({ signedIn, enabled, fixtureCount = 1, isLoading = false }) =>
  Boolean(signedIn && enabled && fixtureCount > 0 && !isLoading);

/** 401/403 means the gate refused the caller; retrying won't change that. */
export const isGateRefusal = (status) => status === 401 || status === 403;
